import type { Position } from 'geojson';
import { useState } from 'react';
import { getUsersGeoLocation } from 'utils/geolocationUtil';

const useUserGeoLocation = () => {
    const [userGeoLocation, setUserGeoLocation] = useState<Position>();

    const getUserGeolocation = async () => {
        if (userGeoLocation) {
            return userGeoLocation;
        }

        try {
            const position = (await getUsersGeoLocation()) as GeolocationPosition;

            const userGeoLocationAsPosition = [position.coords.longitude, position.coords.latitude];

            setUserGeoLocation(userGeoLocationAsPosition);

            return userGeoLocationAsPosition;
        } catch {
            console.warn('Failed to get user geolocation');
        }

        return undefined;
    };

    return {
        getUserGeolocation,
        userGeoLocation
    };
};

export default useUserGeoLocation;
